import type { Role } from '@/types';

import type { OrderStatus } from './types';

/** Internal all-orders view (ADR-0001 amendment 2026-06-25). Dealer is denied here;
 *  the Dealer-scoped order view is a separate later story. Field Technician is denied. */
export const ORDERS_ROLES: Role[] = ['super_admin', 'admin', 'customer_support_logistics'];

/** Human page name surfaced in the access-denied toast. */
export const ORDERS_PAGE_NAME = 'Orders Management';

// ── Order Detail (feature 102116) ─────────────────────────────────────────────

/** Allowed status transitions per current status (102123). Delivered/Cancelled are final.
 *  Backward shipped → order_placed is permitted (non-sequential). */
export const STATUS_TRANSITIONS: Record<OrderStatus, OrderStatus[]> = {
  order_placed: ['shipped', 'delivered', 'cancelled'],
  shipped: ['order_placed', 'delivered', 'cancelled'],
  delivered: [],
  cancelled: [],
};

/** Delivered + Cancelled: no further status changes, read-only "Final Status". */
export const FINAL_STATUSES: OrderStatus[] = ['delivered', 'cancelled'];

export const isFinalStatus = (status: OrderStatus): boolean => FINAL_STATUSES.includes(status);

/** Replacement requests are only available within this many days of delivery (102124). */
export const REPLACEMENT_WINDOW_DAYS = 10;

/** Max open/active support tickets before "Raise a ticket" is blocked (102124). */
export const OPEN_TICKET_LIMIT = 10;

/** AC-verbatim error copy (server is source of truth; FE mirrors). */
export const ORDER_ERRORS = {
  installationPending:
    'Installation request is in pending status. Please approve or reject the installation request before changing the order status to Delivered.',
  openTicketLimit:
    'Open Support ticket limit has reached the maximum. Please resolve existing tickets to create one.',
  deliveryBeforeOrderDate: 'Delivery date cannot be before order placed date',
} as const;
